import { Button, Icon } from '@mage-ui/components';
import { cx } from '@mage-ui/styled-system/css';
import { captionWrapper, focus, text } from '@mage-ui/styled-system/recipes';

export const CaptionWrapper = ({
	caption,
	onClick,
	children,
	id,
	className,
	classNames,
	...props
}) => (
	<figure className={cx(captionWrapper().root, className)} id={id} {...props}>
		{onClick ? (
			<Button
				classNames={{
					root: cx(captionWrapper().btn, focus()),
				}}
				onClick={onClick}
			>
				<span className={cx(captionWrapper().content, classNames?.content)}>
					{children}
				</span>
				<span className={cx(captionWrapper().icon, classNames?.icon)}>
					<Icon name='zoom_in' aria-hidden='true' />
				</span>
			</Button>
		) : (
			children
		)}

		{caption && (
			<figcaption className={text({ size: '4', weight: 'medium' })}>
				{caption}
			</figcaption>
		)}
	</figure>
);
